import {NgModule} from '@angular/core';
import {AppToastrConfig} from '@shared/libraries/ngx-toastr/config/toastr.config';
import {ToastrModule} from 'ngx-toastr';

@NgModule({
  declarations: [],
  imports: [
    ToastrModule.forRoot(AppToastrConfig)
  ]
})
export class AppToastrModule { }
